import { Link, NavLink, Outlet } from "react-router-dom";
import { useAuth } from "@rekonas/auth";
import { Button, cn } from "@rekonas/ui";
import rekonasLogo from "../assets/rekonas-logo.png";

export function AppShell() {
  const { user, logout } = useAuth();
  const identity = String(user?.name || user?.email || user?.username || "Signed in");

  return (
    <div className="operational-app">
      <header className="operational-global-header">
        <div className="operational-header-inner">
          <div className="flex items-center gap-7">
            <Link to="/recordings" className="operational-brand">
              <img alt="Rekonas" src={rekonasLogo} />
              <span>
                <strong>Operational</strong>
                <small>Night recordings</small>
              </span>
            </Link>
            <nav aria-label="Primary navigation">
              <NavLink
                to="/recordings"
                className={({ isActive }) =>
                  cn(
                    "operational-nav-link",
                    isActive ? "operational-nav-active" : "",
                  )
                }
              >
                Recordings
              </NavLink>
            </nav>
          </div>
          <div className="flex min-w-0 items-center gap-2 sm:gap-4">
            <span className="operational-account" title={identity}>
              {identity}
            </span>
            <Button variant="ghost" size="sm" onClick={logout}>
              Sign out
            </Button>
          </div>
        </div>
      </header>
      <Outlet />
    </div>
  );
}
